import { wishlist } from '~/js/common/wishlist'

class AddToWishlist {
    static SELECTORS = {
        root: '[data-add-to-wishlist]'
    }
    static CLASSES = {
        added: 'show-added',
        previouslyAdded: 'previously-added',
        silent: 'animation-silent'
    }

    $elements = {
        root: null
    }

    #variantId = null;
    #optionValues = null;

    productAdded = false

    wishlist = wishlist

    constructor(root) {
        this.$elements.root = root;
        this.#variantId = this.$elements.root.getAttribute(AddToWishlist.SELECTORS.root.replace('[', '').replace(']', ''));
        this.#optionValues = this.$elements.root.dataset.optionValues;

        if (this.#variantId) {
            this.$elements.root.addEventListener('click', this.handleClick.bind(this))
            this.refreshStatus(true);
        } else {
            console.error('No product handle found for add to wishlist button')
            this.disable();
        }
    }

    /**
     * FUNCTIONS
     */

    refreshStatus(silent = false) {
        if (this.wishlist.isOnWishlist(this.#variantId)) {
            this.productAdded = true;

            if (silent) {
                this.showPreviouslyAdded()
            } else {
                this.showAdded()
            }
        } else {
            this.productAdded = false;


            this.hidePreviouslyAdded()
            this.hideAdded()
        }

        if (silent) {
            // Force reflow before removing the class again
            // so the browser registers the change
            void this.$elements.root.offsetWidth;
            // NOTE: ChatGPT suggested this specific change. It may not be necessary
            this.$elements.root.classList.remove(AddToWishlist.CLASSES.silent);
        }
    }

    showPreviouslyAdded() {
        this.$elements.root.classList.add(AddToWishlist.CLASSES.previouslyAdded)
    }

    hidePreviouslyAdded() {
        this.$elements.root.classList.remove(AddToWishlist.CLASSES.previouslyAdded)
    }

    showAdded() {
        this.$elements.root.classList.add(AddToWishlist.CLASSES.added)
    }

    hideAdded() {
        this.$elements.root.classList.remove(AddToWishlist.CLASSES.added)
    }

    disable() {
        this.$elements.root.setAttribute('disabled', '')
    }

    enable() {
        this.$elements.root.removeAttribute('disabled')
    }

    addToWishlist() {
        this.wishlist.addProduct({variantId: this.#variantId, optionValues: this.#optionValues})
    }

    removeFromWishlist() {
        this.wishlist.removeProductByVariantId(this.#variantId)
    }

    /**
     * EVENTS
     */

    handleClick() {
        if (this.productAdded) {
            this.removeFromWishlist()
            this.refreshStatus()
        } else {
            this.addToWishlist()
            this.refreshStatus()
        }
    }
}

if (document.querySelector(AddToWishlist.SELECTORS.root)) {
    const addButtons = document.querySelectorAll(AddToWishlist.SELECTORS.root)
    addButtons.forEach(button => {
        new AddToWishlist(button);
    })
}